/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from "@atproto/lex";
import * as EmbedExternal from "../embed/external.defs.js";

const $nsid = "app.bsky.actor.status";

export { $nsid };

/** Advertises an account as currently offering live content. */
type Live = "app.bsky.actor.status#live";

export type { Live };

/** Advertises an account as currently offering live content. */
const live = /*#__PURE__*/ l.token($nsid, "live");

export { live };

/** A declaration of a Bluesky account status. */
type Main = { $type: "app.bsky.actor.status";

  /**
   * An optional embed associated with the status.
   */
  "embed"?:l.$Typed<EmbedExternal.Main> | l.Unknown$TypedObject;

  /**
   * The status for the account.
   */
  "status":"app.bsky.actor.status#live" | l.UnknownString;"createdAt":l.DatetimeString;

  /**
   * The duration of the status in minutes. Applications can choose to impose minimum and maximum limits.
   */
  "durationMinutes"?:number };

export type { Main };

/** A declaration of a Bluesky account status. */
const main = /*#__PURE__*/ l.record<"literal:self", Main>("literal:self", $nsid, /*#__PURE__*/ l.object({"embed":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.typedUnion([/*#__PURE__*/ l.typedRef<EmbedExternal.Main>((() => EmbedExternal.main) as any)], false)),"status":/*#__PURE__*/ l.string<{"knownValues":["app.bsky.actor.status#live"]}>(),"createdAt":/*#__PURE__*/ l.string({"format":"datetime"}),"durationMinutes":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer({"minimum":1}))}));

export { main };

export const $type = $nsid;
export const $isTypeOf = /*#__PURE__*/ main.isTypeOf.bind(main);
export const $build = /*#__PURE__*/ main.build.bind(main);
export const $assert = /*#__PURE__*/ main.assert.bind(main);
export const $check = /*#__PURE__*/ main.check.bind(main);
export const $cast = /*#__PURE__*/ main.cast.bind(main);
export const $ifMatches = /*#__PURE__*/ main.ifMatches.bind(main);
export const $matches = /*#__PURE__*/ main.matches.bind(main);
export const $parse = /*#__PURE__*/ main.parse.bind(main);
export const $safeParse = /*#__PURE__*/ main.safeParse.bind(main);
export const $validate = /*#__PURE__*/ main.validate.bind(main);
export const $safeValidate = /*#__PURE__*/ main.safeValidate.bind(main);
